<template>
  <div class="lp">

    <!-- ===== HERO IMAGE ===== -->
    <section class="lp-hero-img">
      <img src="@/assets/1.png" alt="용인남사 대우이안 플렉시티" />
      <img src="@/assets/2.png" alt="용인남사 대우이안 플렉시티" />
    </section>

    <!-- ===== 사업 개요 ===== -->
    <section class="lp-section lp-overview-head">
      <div class="lp-inner">
        <span class="lp-eyebrow">— O V E R V I E W —</span>
        <h2 class="lp-section-title">
          용인 2,018세대 대단지<br/>
          10년 민간임대 아파트<br/>
          <em>미래가치가 시작되는 중심</em>
        </h2>
        <div class="lp-gold-line"></div>
        <p class="lp-lead">
          세계최대 규모의 <strong>첨단 시스템 반도체 클러스터</strong> 바로 앞,<br/>
          가장 가까이에서 프리미엄을 누릴 수 있습니다.
        </p>
      </div>
    </section>

    <!-- ===== HERO IMAGE ===== -->
    <section class="lp-hero-img">
      <img src="@/assets/3.png" alt="용인남사 대우이안 플렉시티" />
    </section>

    <!-- ===== 사업 개요 - 데이터 ===== -->
    <section class="lp-section lp-overview">
      <div class="lp-inner">
        <dl class="ov-list">
          <div class="ov-row" v-for="(it, i) in overviewItems" :key="i">
            <dt class="ov-label">{{ it.label }}</dt>
            <dd class="ov-value" v-html="it.value"></dd>
          </div>
        </dl>
      </div>
    </section>

    <!-- ===== LOCATION (입지환경) ===== -->
    <section class="lp-section lp-location">
      <div class="lp-inner">
        <span class="lp-eyebrow">— L O C A T I O N —</span>
        <h2 class="lp-section-title">
          삼성반도체 클러스터<br/>
          <em>최인접 프리미엄 수혜지</em>
        </h2>
        <div class="lp-gold-line"></div>
        <p class="lp-lead">
          <strong>778만㎡ 규모의 매머드 스케일</strong> 삼성전자 반도체 클러스터 최인접 수혜지,<br/>
          대우이안 플렉시티가 가장 큰 프리미엄의 중심입니다.
        </p>

        <ul class="loc-list">
          <li class="loc-item" v-for="(it, i) in locationItems" :key="i">
            <span class="loc-num">0{{ i + 1 }}</span>
            <div class="loc-text">
              <h3 class="loc-title">{{ it.title }}</h3>
              <p class="loc-desc" v-html="it.desc"></p>
            </div>
          </li>
        </ul>

        <figure class="loc-map">
          <img src="@/assets/4.png" alt="용인남사 대우이안 플렉시티 입지도" />
        </figure>
      </div>
    </section>

    <!-- ===== THE PREMIUM 8 ===== -->
    <section class="lp-section lp-ultimate">
      <div class="lp-inner">
        <span class="lp-eyebrow light">— T H E &nbsp; P R E M I U M —</span>
        <h2 class="lp-section-title white">
          용인남사 대우이안 플렉시티를 완성하는<br/>
          <em>여덟 가지 프리미엄</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="ult-grid">
          <article class="ult-card" v-for="(it, i) in ultimateItems" :key="i">
            <header class="ult-card-head">
              <span class="ult-num">0{{ i + 1 }}</span>
              <span class="ult-tag">PREMIUM</span>
            </header>
            <h3 class="ult-title">{{ it.title }}</h3>
            <div class="ult-line"></div>
            <p class="ult-desc" v-html="it.desc"></p>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== PLOT PLAN ===== -->
    <section class="lp-section lp-plot">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— P L O T &nbsp; P L A N —</span>
        <h2 class="lp-section-title">
          총 2,018세대, 15개동의<br/>
          <em>단지 배치</em>
        </h2>
        <div class="lp-gold-line"></div>

        <p class="plot-lead">
          지하 2층 ~ 지상 29층, <strong>용인남사 대우이안 플렉시티</strong>의 2개 블록 단지 구성을 한눈에.
        </p>

        <div class="plot-grid">
          <figure class="plot-fig">
            <img class="plot-img" src="@/assets/동호배치도1.png" alt="용인남사 대우이안 플렉시티 동호배치도 1블록" />
          </figure>
          <figure class="plot-fig">
            <img class="plot-img" src="@/assets/동호배치도2.png" alt="용인남사 대우이안 플렉시티 동호배치도 2블록" />
          </figure>
        </div>
        <p class="plot-cap">※ 본 배치도는 이해를 돕기 위한 자료이며 실제와 다를 수 있습니다.</p>
      </div>
    </section>

    <!-- ===== COMMUNITY ===== -->
    <section class="lp-section lp-amenity">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— C O M M U N I T Y —</span>
        <h2 class="lp-section-title">
          단지를 넘어선<br/>
          <em>거주의 정원</em>
        </h2>
        <div class="lp-gold-line"></div>

        <figure class="community-fig">
          <img src="@/assets/커뮤니티1.jpg" alt="용인남사 대우이안 플렉시티 커뮤니티 시설" />
        </figure>
      </div>
    </section>

    <!-- ===== UNIT ===== -->
    <section class="lp-section lp-unit">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— U N I T &nbsp; P L A N —</span>
        <h2 class="lp-section-title">
          다양한 라이프스타일,<br/>
          <em>6가지 평면</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="unit-tabs">
          <button
            v-for="(u, i) in unitTypes"
            :key="u.label"
            class="unit-tab"
            :class="{ active: activeUnit === i }"
            @click="setUnit(i)">
            <span class="ut-label">{{ u.label }}</span>
          </button>
        </div>

        <div class="unit-imgs">
          <figure class="unit-img-wrap">
            <figcaption class="unit-img-label">ISOMETRIC</figcaption>
            <img
              :src="getUnitImg(unitTypes[activeUnit].iso)"
              :alt="unitTypes[activeUnit].label + ' 아이소'"
              class="unit-img"
              :class="{ 'is-loading': unitLoading }"
              @load="onUnitImgLoad"
            />
            <transition name="unit-fade">
              <div v-if="unitLoading" class="unit-loading">
                <span class="unit-spinner"></span>
                <span class="unit-loading-label">LOADING</span>
              </div>
            </transition>
          </figure>
          <figure class="unit-img-wrap">
            <figcaption class="unit-img-label">FLOOR PLAN</figcaption>
            <img
              :src="getUnitImg(unitTypes[activeUnit].plan)"
              :alt="unitTypes[activeUnit].label + ' 평면도'"
              class="unit-img"
              :class="{ 'is-loading': unitLoading }"
              @load="onUnitImgLoad"
            />
            <transition name="unit-fade">
              <div v-if="unitLoading" class="unit-loading">
                <span class="unit-spinner"></span>
                <span class="unit-loading-label">LOADING</span>
              </div>
            </transition>
          </figure>
        </div>
      </div>
    </section>

    <!-- ===== 분양 조건 ===== -->
    <section class="lp-section lp-offer">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— S P E C I A L &nbsp; O F F E R —</span>
        <h2 class="lp-section-title">
          이런 조건<br/>
          <em>다시는 안 나옵니다</em>
        </h2>
        <div class="lp-gold-line"></div>

        <ul class="offer-grid">
          <li class="offer-card offer-hero">
            <span class="offer-label">입주까지 단</span>
            <span class="offer-value">3,500<small>만원</small></span>
            <span class="offer-sub">10년 전세형 아파트</span>
          </li>
          <li class="offer-card offer-hero">
            <span class="offer-label">세금</span>
            <span class="offer-value">Z E R O</span>
            <span class="offer-sub">취득세 · 보유세 · 종부세 · 양도세 없음</span>
          </li>
          <li class="offer-card">
            <span class="offer-label">중도금</span>
            <span class="offer-value">전액 무이자</span>
          </li>
          <li class="offer-card">
            <span class="offer-label">확장비</span>
            <span class="offer-value">전액 무상</span>
          </li>
          <li class="offer-card">
            <span class="offer-label">거래</span>
            <span class="offer-value">전매·전대 가능</span>
          </li>
          <li class="offer-card">
            <span class="offer-label">보증</span>
            <span class="offer-value">HUG 보증</span>
          </li>
        </ul>

        <p class="offer-extra">
          만 19세 이상 전국민 누구나 · 다주택자 가능 · 주택수 미포함
        </p>
      </div>
    </section>

    <!-- ===== RESERVATION CTA ===== -->
    <section class="lp-section lp-cta">
      <div class="lp-inner narrow center">
        <span class="lp-eyebrow light">— R E S E R V A T I O N —</span>
        <h2 class="lp-section-title white">
          방문예약 이벤트<br/>
          <em>로얄층 선착순 동/호지정 중</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="cta-event">
          <p class="cta-event-prize">
            <span class="cta-star">★</span>
            로얄층 선착순 동/호지정 중
            <span class="cta-star">★</span>
          </p>
        </div>

        <button class="cta-btn" @click="openRegister">
          <span class="cta-btn-en">PRIVATE RESERVATION</span>
          <span class="cta-btn-kr">방문 예약하기</span>
          <span class="cta-btn-arrow">→</span>
        </button>

        <p class="cta-note">
          ※ 본 사이트는 용인남사 대우이안 플렉시티 분양 상담 및 방문 예약 안내 페이지입니다.<br/>
          시행사·시공사의 공식 홈페이지가 아닙니다.
        </p>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'MainView',
  data() {
    return {

ultimateItems: [
        { title: '삼성반도체 최대 수혜지', desc: '<strong>360조 투자 확정</strong> 삼성 반도체 클러스터 1km.' },
        { title: '광역교통 네트워크',     desc: '<strong>경강선 연장</strong>·반도체고속도로(계획) 등 사방으로 뻗는 도로망.' },
        { title: '힐링 & 그린라이프',     desc: '<strong>달봉산·한림용인CC</strong>를 누리는 도심 속 자연.' },
        { title: '최상의 미래가치',       desc: '<strong>용인 남사 아곡 도시개발사업</strong> 등 풍부한 개발 호재.' },
        { title: '완벽한 생활 인프라',    desc: '<strong>단지내 대형 마트(예정)</strong>·롯데프레쉬 등 원스톱 라이프.' },
        { title: '도보생활권 교육환경',   desc: '<strong>단지내 대형 어학원(예정)</strong>으로 안심 교육 인프라.' },
        { title: '더 넓어진 공간구성',    desc: '<strong>대피공간 대체시설</strong> 적용으로 한층 여유로운 평면.' },
        { title: '분양전환 가능한 아파트', desc: '<strong>10년간 임대 후 분양전환</strong> 가능한 안심 주거.' },
      ],

      overviewItems: [
        { label: '사업유형', value: '10년 민간임대 아파트' },
        { label: '단지명',   value: '용인남사 대우이안 플렉시티' },
        { label: '세대수',   value: '총 2,018세대' },
        { label: '위치',     value: '용인특례시 처인구 남사읍 아곡리 456번지 일원' },
        { label: '규모',     value: '지하 2층 ~ 지상 29층, 15개동' },
        { label: '면적',     value: '연면적 288,178.24㎡<br/>건축면적 20,516.00㎡<br/>대지면적 82,065.00㎡' },
      ],

      locationItems: [
        { title: '따라올 수 없는 입지',  desc: '<strong>삼성전자 첨단 시스템반도체 클러스터(예정)</strong>, SK하이닉스 용인 반도체클러스터(공사중), 테크노밸리 산업단지 등 인접 최대 수혜지.' },
        { title: '막힘이 없는 교통',    desc: '처인성로·경기동로·<strong>세종~포천 고속도로</strong>·경강선 연장(계획)·반도체고속도로(계획) 등 빠르게 연결하는 광역교통망.' },
        { title: '비교할 수 없는 생활',  desc: '단지앞 공원·마을회관·<strong>용인반도체마이스터고(예정)</strong>와 인근 반도체 클러스터 배후단지의 생활인프라 이용 편리.' },
        { title: '놓칠 수 없는 가치',   desc: '역삼·역북 미래개발가치, 반도체벨트 조성으로 인한 <strong>배후주거지 후광효과</strong>, 민간임대아파트의 합리적인 모집가.' },
      ],

      unitTypes: [
        { label: '49A', iso: '49A아이소.png',  plan: '49A평면도.png' },
        { label: '49B', iso: '49B아이소.png',  plan: '49B평면도.png' },
        { label: '59A', iso: '59A아이소.png',  plan: '59A평면도.png' },
        { label: '59B', iso: '59B아이소.png',  plan: '59B평면도.png' },
        { label: '84A', iso: '84A아이소.png',  plan: '84A평면도.png' },
        { label: '84B', iso: '84B 아이소.png', plan: '84B 평면도.png' },
      ],
      activeUnit: 0,
      unitLoading: true,
      unitLoadedCount: 0,
    }
  },
  mounted() {
    this.preloadUnitImages()
  },
  methods: {
    openRegister() {
      window.dispatchEvent(new Event('open-register-popup'))
    },
    getUnitImg(name) {
      return require('@/assets/unit/' + name)
    },
    setUnit(idx) {
      if (this.activeUnit === idx) return
      this.unitLoading = true
      this.unitLoadedCount = 0
      this.activeUnit = idx
    },
    onUnitImgLoad() {
      this.unitLoadedCount++
      if (this.unitLoadedCount >= 2) {
        this.unitLoading = false
      }
    },
    preloadUnitImages() {
      this.unitTypes.forEach(u => {
        [u.iso, u.plan].forEach(name => {
          const img = new Image()
          img.src = require('@/assets/unit/' + name)
        })
      })
    }
  }
}
</script>

<style scoped>
/* ==================== ROOT ==================== */
.lp {
  background: #ffffff;
  color: var(--le-ink);
  font-family: var(--font-sans);
  letter-spacing: -0.01em;
  overflow-x: hidden;
}

.lp em {
  font-family: var(--font-serif-en);
  font-style: italic;
  font-weight: 400;
  color: var(--le-champagne-dark);
}

.lp strong { font-weight: 600; color: var(--le-noir); }

.lp-inner {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 22px;
}
.lp-inner.narrow { max-width: 760px; }
.lp-inner.center { text-align: center; }

.lp-section {
  padding: 96px 0;
  position: relative;
}

.lp-eyebrow {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.38em;
  font-weight: 500;
  color: var(--le-champagne-dark);
  margin-bottom: 22px;
}
.lp-eyebrow.light { color: var(--le-champagne); }

.lp-section-title {
  font-family: var(--font-serif-kr);
  font-weight: 300;
  font-size: 32px;
  line-height: 1.45;
  color: var(--le-noir);
  letter-spacing: -0.02em;
  margin-bottom: 28px;
}
.lp-section-title em {
  font-family: var(--font-serif-en);
  font-weight: 400;
  font-style: italic;
  color: var(--le-champagne-dark);
}
.lp-section-title.white { color: var(--le-ink); }
.lp-section-title.white em { color: var(--le-champagne-dark); }
.lp-section-title.light { font-weight: 200; }

.lp-gold-line {
  width: 60px; height: 1px;
  background: linear-gradient(90deg, var(--le-champagne), rgba(15,71,81,0));
  margin: 0 0 40px;
}
.lp-gold-line.short { width: 36px; margin: 18px 0; }

/* ==================== HERO IMAGE ==================== */
.lp-hero-img {
  width: 100%;
  background: #ffffff;
  line-height: 0;
}
.lp-hero-img img {
  display: block;
  width: 100%;
  height: auto;
}

/* ==================== ULTIMATE 8 ==================== */
.lp-ultimate {
  background: #ffffff;
  padding: 120px 0;
  position: relative;
}
.lp-ultimate::before, .lp-ultimate::after {
  content: ''; position: absolute; left: 0; right: 0; height: 1px;
  background: linear-gradient(90deg, transparent, var(--le-champagne), transparent);
}
.lp-ultimate::before { top: 0; opacity: 0.5; }
.lp-ultimate::after { bottom: 0; opacity: 0.5; }

.ult-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0;
  margin-top: 14px;
  border-top: 1px solid rgba(15,71,81,0.18);
  border-left: 1px solid rgba(15,71,81,0.18);
}
.ult-card {
  padding: 24px 14px 26px;
  border-right: 1px solid rgba(15,71,81,0.18);
  border-bottom: 1px solid rgba(15,71,81,0.18);
  position: relative;
  display: flex;
  flex-direction: column;
}
.ult-card-head {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 16px;
}
.ult-num {
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  background: var(--le-champagne);
  line-height: 1;
  padding: 8px 12px;
  border-radius: 999px;
  letter-spacing: 0.04em;
}
.ult-tag {
  font-family: var(--font-sans);
  font-size: 9px;
  letter-spacing: 0.3em;
  color: rgba(15,71,81,0.7);
  font-weight: 600;
}
.ult-title {
  font-family: var(--font-rounded);
  font-size: 19px;
  font-weight: 700;
  color: var(--le-ink);
  margin-bottom: 10px;
  letter-spacing: -0.02em;
  line-height: 1.35;
}
.ult-line {
  width: 24px; height: 2px;
  background: var(--le-champagne);
  margin-bottom: 14px;
  border-radius: 2px;
}
.ult-desc {
  font-family: var(--font-sans);
  font-weight: 400;
  font-size: 13px;
  line-height: 1.7;
  color: rgba(11,11,15,0.7);
  letter-spacing: -0.01em;
}
.ult-desc strong {
  color: var(--le-champagne-dark);
  font-weight: 600;
}

/* ==================== OVERVIEW (사업 개요) ==================== */
.lp-overview-head {
  background: #ffffff;
  padding: 80px 0 36px;
}
.lp-lead {
  margin-top: 18px;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.85;
  color: rgba(11, 11, 15, 0.7);
  letter-spacing: -0.01em;
  word-break: keep-all;
}
.lp-lead strong {
  color: var(--le-champagne-dark);
  font-weight: 600;
}
.lp-overview {
  background: #ffffff;
  padding: 36px 0 90px;
}
.ov-list {
  margin: 8px 0 0;
  padding: 0;
  border-top: 2px solid var(--le-champagne);
  border-bottom: 1px solid rgba(11, 11, 15, 0.08);
}
.ov-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 16px;
  padding: 18px 4px;
  border-bottom: 1px solid rgba(11, 11, 15, 0.06);
  align-items: start;
}
.ov-row:last-child {
  border-bottom: none;
}
.ov-label {
  font-family: var(--font-rounded);
  font-size: 13px;
  font-weight: 700;
  color: var(--le-champagne-dark);
  letter-spacing: -0.01em;
  line-height: 1.6;
}
.ov-value {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  color: var(--le-ink);
  line-height: 1.6;
  letter-spacing: -0.01em;
  word-break: keep-all;
  margin: 0;
}

/* ==================== LOCATION (입지환경) ==================== */
.lp-location {
  background: #ffffff;
  padding: 90px 0 110px;
}
.loc-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.loc-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 22px 20px;
  background: #ffffff;
  border: 1px solid rgba(15, 71, 81, 0.18);
  border-radius: 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.loc-item:hover {
  border-color: var(--le-champagne);
  box-shadow: 0 8px 24px -12px rgba(15, 71, 81, 0.35);
}
.loc-num {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--le-champagne);
  color: #ffffff;
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.loc-text {
  flex: 1;
  min-width: 0;
}
.loc-title {
  font-family: var(--font-rounded);
  font-size: 18px;
  font-weight: 700;
  color: var(--le-ink);
  margin: 4px 0 8px;
  letter-spacing: -0.02em;
  line-height: 1.3;
}
.loc-desc {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.7;
  color: rgba(11, 11, 15, 0.7);
  letter-spacing: -0.01em;
}
.loc-desc strong {
  color: var(--le-champagne-dark);
  font-weight: 600;
}
.loc-map {
  margin: 36px 0 0;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(15, 71, 81, 0.18);
}
.loc-map img {
  display: block;
  width: 100%;
  height: auto;
}

/* ==================== PLOT PLAN ==================== */
.lp-plot {
  background: #ffffff;
  padding: 110px 0 120px;
}
.lp-plot .lp-gold-line {
  margin-left: auto;
  margin-right: auto;
}
.plot-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 1.9;
  color: var(--le-ink);
  text-align: center;
  margin-top: 4px;
  margin-bottom: 36px;
}
.plot-lead strong {
  color: var(--le-champagne-dark, #0F4751);
  font-weight: 500;
}
.plot-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.plot-fig {
  margin: 0;
  position: relative;
  padding: 14px;
  background: linear-gradient(180deg, #EEF2F4 0%, #D8E2E5 100%);
  border: 1px solid rgba(15, 71, 81, 0.35);
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.4) inset,
    0 24px 50px -20px rgba(11, 11, 15, 0.18);
}
.plot-fig::before,
.plot-fig::after {
  content: '';
  position: absolute;
  width: 14px; height: 14px;
  border: 1px solid var(--le-champagne, #0F4751);
  opacity: 0.7;
}
.plot-fig::before { top: 4px; left: 4px; border-right: none; border-bottom: none; }
.plot-fig::after  { bottom: 4px; right: 4px; border-left: none; border-top: none; }
.plot-img {
  display: block;
  width: 100%;
  height: auto;
}
.plot-cap {
  margin-top: 14px;
  font-family: var(--font-sans);
  font-size: 11px;
  color: var(--le-warm-grey, #7A6E5A);
  text-align: center;
  letter-spacing: 0.02em;
}

/* ==================== COMMUNITY ==================== */
.lp-amenity {
  background: #ffffff;
  padding: 110px 0;
}
.lp-amenity .lp-gold-line {
  margin-left: auto;
  margin-right: auto;
}
.community-fig {
  margin: 30px 0 0;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(15, 71, 81, 0.18);
}
.community-fig img {
  display: block;
  width: 100%;
  height: auto;
}

/* ==================== UNIT ==================== */
.lp-unit {
  background: var(--le-pearl);
  padding: 110px 0;
}
.lp-unit .lp-gold-line {
  margin-left: auto;
  margin-right: auto;
}
.unit-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  margin: 8px 0 28px;
  padding: 4px 0;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}
.unit-tabs::-webkit-scrollbar { display: none; }

.unit-tab {
  flex-shrink: 0;
  background: #ffffff;
  border: 1px solid rgba(15, 71, 81, 0.3);
  padding: 10px 18px;
  cursor: pointer;
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--le-ink);
  border-radius: 999px;
  transition: all 0.25s ease;
}
.unit-tab:hover {
  border-color: var(--le-champagne);
}
.unit-tab.active {
  background: var(--le-champagne);
  border-color: var(--le-champagne);
  color: #ffffff;
  box-shadow: 0 8px 20px -10px rgba(15, 71, 81, 0.5);
}

.unit-imgs {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.unit-img-wrap {
  position: relative;
  width: 100%;
  min-height: 240px;
  margin: 0;
  background: #ffffff;
  border: 1px solid rgba(15, 71, 81, 0.18);
  border-radius: 16px;
  overflow: hidden;
}
.unit-img-label {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 2;
  padding: 6px 12px;
  background: var(--le-champagne);
  color: #ffffff;
  font-family: var(--font-mono-disp);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.22em;
  border-radius: 999px;
  box-shadow: 0 4px 10px -4px rgba(15, 71, 81, 0.5);
}
.unit-img {
  display: block;
  width: 100%;
  height: auto;
  transition: opacity 0.35s ease;
}
.unit-img.is-loading {
  opacity: 0.3;
}

.unit-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  pointer-events: none;
}
.unit-spinner {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(15, 71, 81, 0.2);
  border-top-color: var(--le-champagne, #0F4751);
  animation: unitSpin 0.8s linear infinite;
}
.unit-loading-label {
  font-family: var(--font-sans);
  font-size: 10px;
  letter-spacing: 0.42em;
  color: var(--le-champagne-dark, #08323A);
  font-weight: 600;
}

@keyframes unitSpin {
  to { transform: rotate(360deg); }
}

.unit-fade-enter-active,
.unit-fade-leave-active {
  transition: opacity 0.3s ease;
}
.unit-fade-enter-from,
.unit-fade-leave-to {
  opacity: 0;
}

/* ==================== SPECIAL OFFER (분양 조건) ==================== */
.lp-offer {
  background: #ffffff;
  padding: 100px 0 110px;
}
.offer-grid {
  list-style: none;
  padding: 0;
  margin: 24px 0 28px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.offer-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 22px 16px;
  background: #ffffff;
  border: 1px solid rgba(15, 71, 81, 0.22);
  border-radius: 16px;
  text-align: center;
  min-height: 110px;
}
.offer-card.offer-hero {
  grid-column: span 2;
  background: linear-gradient(135deg, var(--le-champagne), var(--le-champagne-dark));
  border-color: var(--le-champagne-dark);
  color: #ffffff;
  min-height: 130px;
  box-shadow: 0 12px 28px -12px rgba(15, 71, 81, 0.45);
}
.offer-label {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2em;
  color: rgba(11, 11, 15, 0.5);
}
.offer-hero .offer-label {
  color: rgba(255, 255, 255, 0.85);
}
.offer-value {
  font-family: var(--font-rounded);
  font-size: 22px;
  font-weight: 800;
  color: var(--le-ink);
  letter-spacing: -0.02em;
  line-height: 1.1;
}
.offer-hero .offer-value {
  font-size: 28px;
  color: #ffffff;
}
.offer-value sup {
  font-size: 0.6em;
  vertical-align: super;
  margin-left: 2px;
}
.offer-value small {
  font-size: 0.6em;
  font-weight: 700;
  margin-left: 2px;
  opacity: 0.85;
}
.offer-sub {
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: -0.01em;
}
.offer-extra {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  color: rgba(11, 11, 15, 0.7);
  line-height: 1.7;
  margin-top: 8px;
}
.offer-extra strong {
  color: var(--le-champagne-dark);
  font-weight: 700;
}

/* ==================== CTA ==================== */
.lp-cta {
  background: #ffffff;
  color: var(--le-ink);
  padding: 110px 0 130px;
  position: relative;
  overflow: hidden;
}
.lp-cta::before {
  content: '';
  position: absolute; inset: 0;
  background:
    radial-gradient(ellipse at center, rgba(15,71,81,0.08), transparent 60%);
  pointer-events: none;
}
.lp-cta .lp-inner { position: relative; z-index: 2; }
.lp-cta .lp-gold-line { margin-left: auto; margin-right: auto; }
.cta-event {
  margin: 4px 0 38px;
  padding: 30px 24px;
  background: linear-gradient(135deg, var(--le-champagne), var(--le-champagne-dark));
  border-radius: 18px;
  box-shadow: 0 16px 32px -16px rgba(15, 71, 81, 0.55);
  color: #ffffff;
}
.cta-event-period {
  display: inline-block;
  padding: 5px 14px;
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  font-family: var(--font-mono-disp);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: #ffffff;
}
.cta-event-body {
  font-family: var(--font-serif-kr);
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.7;
  margin-bottom: 14px;
}
.cta-event-prize {
  font-family: var(--font-rounded);
  font-size: 22px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.cta-star {
  color: var(--le-lime, #94C84D);
  font-size: 18px;
  animation: ctaStarBlink 1.4s ease-in-out infinite;
}
.cta-star:last-child { animation-delay: 0.7s; }
@keyframes ctaStarBlink {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.85); }
}
.cta-desc {
  font-family: var(--font-serif-kr);
  font-weight: 400;
  font-size: 16px;
  line-height: 2;
  color: rgba(11,11,15,0.78);
  margin-bottom: 38px;
}
.cta-desc strong {
  color: var(--le-champagne-dark);
  font-weight: 600;
}
.cta-btn {
  background: var(--le-champagne);
  border: 1px solid var(--le-champagne);
  color: #ffffff;
  padding: 22px 30px;
  font-family: inherit;
  cursor: pointer;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
}
.cta-btn::before {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(135deg, var(--le-champagne-dark), var(--le-champagne));
  transform: translateY(101%);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 0;
}
.cta-btn:hover::before { transform: translateY(0); }
.cta-btn > * { position: relative; z-index: 1; }
.cta-btn:hover { color: #ffffff; border-color: var(--le-champagne-dark); }
.cta-btn-en {
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.4em;
  color: #ffffff;
  font-weight: 500;
  transition: color 0.4s;
}
.cta-btn-kr {
  font-family: var(--font-serif-kr);
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.cta-btn-arrow {
  font-family: var(--font-serif-en);
  font-size: 18px;
  margin-top: 4px;
  color: #ffffff;
  transition: all 0.4s;
}
.cta-btn:hover .cta-btn-arrow { transform: translateX(4px); }

.cta-note {
  margin-top: 36px;
  font-family: var(--font-serif-kr);
  font-size: 11px;
  color: rgba(11,11,15,0.45);
  line-height: 1.8;
  font-weight: 400;
}

/* ==================== RESPONSIVE (Tablet+) ==================== */
@media (min-width: 768px) {
  .lp-inner { padding: 0 40px; }
  .lp-section { padding: 130px 0; }

  .lp-section-title { font-size: 44px; margin-bottom: 36px; }
  .lp-eyebrow { font-size: 12px; margin-bottom: 28px; }
  .lp-gold-line { width: 80px; margin-bottom: 56px; }
  .lp-lead { font-size: 16px; margin-top: 24px; }

  .plot-grid { flex-direction: row; gap: 32px; }
  .plot-grid .plot-fig { flex: 1; min-width: 0; }

  .unit-imgs { flex-direction: row; gap: 24px; }
  .unit-imgs .unit-img-wrap { flex: 1; min-width: 0; }


  .ult-grid {
    grid-template-columns: repeat(2, 1fr);
    border-left: 1px solid rgba(15,71,81,0.18);
  }
  .ult-card {
    border-right: 1px solid rgba(15,71,81,0.18);
    padding: 50px 32px 56px;
  }
  .ult-title { font-size: 22px; }
}

@media (min-width: 1024px) {
  .lp-section { padding: 160px 0; }
  .lp-section-title { font-size: 52px; }
  .ult-grid { grid-template-columns: repeat(4, 1fr); }
}
</style>
